import { useState, useCallback } from "react";
import { supabase } from "@project/integrations/supabase/client";
import { toast } from "@project/hooks/use-toast";

export function useAIAction() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  const run = useCallback(async (prompt: string): Promise<string> => {
    const message =
      "AI features are currently unavailable because Supabase has been removed.";
    toast({
      title: "Feature Disabled",
      description: message,
      variant: "destructive",
    });
    setResult("⚠️ " + message);
    return "";
  }, []);

  const reset = useCallback(() => {
    setResult("");
    setLoading(false);
  }, []);

  return { loading, result, run, reset };
}
